import { MrbBaseRouteStore } from "mrb/core";

class DashboardRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default DashboardRouteStore;
